import React from 'react';
const MobileResponsiveError = () => <div className="grid min-h-screen place-content-center px-4 text-center">
    <div>
      <p>
        This feature is only available for desktop, but we’re working on finishing the mobile
        experience.
      </p>
      <p className="py-6">Stay tuned.</p>
    </div>
  </div>;
export default MobileResponsiveError;